import React, { useContext } from 'react';
import styles from './style.module.scss';
import { Dialog, DialogContent, DialogTitle } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { makeStyles } from '@material-ui/core/styles';
import AliceCarousel from 'react-alice-carousel';
import 'react-alice-carousel/lib/scss/alice-carousel.scss';

const useStyles = makeStyles({
  smallPaper: {
    height: 'calc(100vh - 300px)',
    width: 'calc(70% - 250px)',
    borderRadius: '30px',
    '& .alice-carousel': {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    '& .alice-carousel:first-child': {
      '& div:first-child': {
        width: '70%',
      },
    },
    '& .alice-carousel__dots': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '20px',
      maxHeight: '400px',
      overflowY: 'auto',
      overflowX: 'hidden',
      paddingRight: '10px',
    },
    '& .alice-carousel__dots::-webkit-scrollbar': {
      width: '3px',
      background: 'white',
      borderRadius: '8px !important',
    },
    '& .alice-carousel__dots::-webkit-scrollbar-thumb': {
      backgroundColor: '#CAF5FCB2',
      borderRadius: '8px !important',
    },
    '& .alice-carousel__dots::-webkit-scrollbar-track': {
      background: 'white',
      borderRadius: '8px !important',
    },
  },
});

const ImagePreviewComponent = (props) => {
  const classes = useStyles();

  const { open, onClose, images, imageBaseUrl, onDragStart } = props;

  return (
    <Dialog
      classes={{ paper: classes.smallPaper }}
      maxWidth="xl"
      open={open}
      onClose={() => onClose()}
    >
      <DialogTitle
        id="customized-dialog-title"
        onClose={() => onClose()}
        className={styles.modalTitle}
      >
        <div className="d-flex justify-content-end align-items-center">
          <IconButton className={styles.closeBtn} onClick={() => onClose()}>
            <CloseIcon className={styles.searchClose} />
          </IconButton>
        </div>
      </DialogTitle>
      <DialogContent className="m-2">
        <AliceCarousel
          infinite={images.length === 1 ? false : true}
          autoPlayInterval={2000}
          disableButtonsControls
          autoPlay
          mouseTracking
          renderDotsItem={(e) => {
            return (
              <img
                className={`${styles.cursorP} ${styles.smallImgStyle} ${
                  e.isActive ? styles.imgBorder : ''
                }`}
                src={`${imageBaseUrl}${images[e.activeIndex]}`}
              />
            );
          }}
          items={images.map((img) => (
            <img
              style={{ height: '400px', width: '100%', objectFit: 'contain' }}
              onDragStart={onDragStart}
              src={`${imageBaseUrl}${img}`}
            />
          ))}
        />
      </DialogContent>
    </Dialog>
  );
};

export default ImagePreviewComponent;
